export default {
  namespaced: true,
  state: {
    currentPage: 1,
    count: 0,
    lockdownPage: 1,
    lockdownCount: 0,
    expeditionId: 1,
    receptionId: 2
  },
  actions: {
    async expeditions ({ dispatch, state }, params) {
      return dispatch('list', { basePath: 'api/expedition', params: params }, { root: true })
        .then(response => {
          state.count = response.count
          state.currentPage = params.page
          return response.results
        })
        .catch(error => { throw error })
    },
    async receptions ({ dispatch, state }, params) {
      return dispatch('list', { basePath: 'api/reception', params: params }, { root: true })
        .then(response => {
          state.count = response.count
          state.currentPage = params.page
          return response.results
        })
        .catch(error => { throw error })
    },
    async criticalLines ({ dispatch, state }, params) {
      return dispatch('list', { basePath: 'api/critic-line', params: params }, { root: true })
        .then(response => {
          state.count = response.count
          state.currentPage = params.page
          return response.results
        })
        .catch(error => { throw error })
    },
    async patchExpedition ({ dispatch, state }, data) {
      return dispatch('patch', { basePath: 'api/expedition', data: data, id: data.id }, { root: true })
        .then(response => {
          state.object = response
          return response
        })
        .catch(error => { throw error })
    },
    async patchReception ({ dispatch, state }, data) {
      return dispatch('patch', { basePath: 'api/reception', data: data, id: data.id }, { root: true })
        .then(response => {
          state.object = response
          return response
        })
        .catch(error => { throw error })
    },
    async shipments ({ dispatch, state }, params) {
      return dispatch('list', { basePath: 'api/shipment', params: params }, { root: true })
        .then(response => {
          state.count = response.count
          state.currentPage = params.page
          return response.results
        })
        .catch(error => { throw error })
    },
    async historic ({ dispatch, state }, params) {
      return dispatch('list', { basePath: 'api/historic/' + params }, { root: true })
        .then(response => {
          state.count = response.count
          state.currentPage = params.page
          return response.results
        })
        .catch(error => { throw error })
    },
    async save ({ dispatch, state }, data) {
      data[0].type = state[data[1] + 'Id']
      return dispatch('save', { basePath: 'api/' + data[1], data: data[0], id: data[0].id }, { root: true })
        .then(response => {
          state.object = response
          return response
        })
        .catch(error => { throw error })
    },
    async patch ({ dispatch, state }, data) {
      return dispatch('patch', { basePath: 'api/' + data[2], data: data[1], id: data[0] }, { root: true })
        .then(response => {
          state.object = response
          return response
        })
        .catch(error => { throw error })
    },
    async saveExpedition ({ dispatch, state }, data) {
      data.type = state.expeditionId
      return dispatch('save', { basePath: 'api/expedition', data: data, id: data.id }, { root: true })
        .then(response => {
          state.object = response
          return response
        })
        .catch(error => { throw error })
    },
    async saveReception ({ dispatch, state }, data) {
      data.type = state.receptionId
      return dispatch('save', { basePath: 'api/reception', data: data, id: data.id }, { root: true })
        .then(response => {
          state.object = response
          return response
        })
        .catch(error => { throw error })
    },
    async saveCriticalLine ({ dispatch, state }, data) {
      return dispatch('save', { basePath: 'api/critic-line', data: data, id: data.id }, { root: true })
        .then(response => {
          state.object = response
          return response
        })
        .catch(error => { throw error })
    },
    async readExpedition ({ dispatch, state }, id) {
      return dispatch('read', { basePath: 'api/expedition', id: id }, { root: true })
        .then(response => {
          return response
        })
        .catch(error => { throw error })
    },
    async readReception ({ dispatch, state }, id) {
      return dispatch('read', { basePath: 'api/reception', id: id }, { root: true })
        .then(response => {
          return response
        })
        .catch(error => { throw error })
    },
    async readCriticalLine ({ dispatch, state }, id) {
      return dispatch('read', { basePath: 'api/critic-line', id: id }, { root: true })
        .then(response => {
          return response
        })
        .catch(error => { throw error })
    },
    async delete ({ dispatch, state }, id) {
      return dispatch('delete', { basePath: 'api/shipment', id: id }, { root: true })
        .then(response => {
          return response
        })
        .catch(error => { throw error })
    },
    async deleteCriticalLine ({ dispatch, state }, id) {
      return dispatch('delete', { basePath: 'api/critic-line', id: id }, { root: true })
        .then(response => {
          return response
        })
        .catch(error => { throw error })
    },
    async addDoc ({ dispatch, state }, data) {
      data.type = state.expeditionId
      return dispatch('multipartRequest', { method: 'post', url: 'api/media', data: data }, { root: true })
        .then(response => {
          state.object = response
          return response
        })
        .catch(error => { throw error })
    },
    async listAttachments ({ dispatch, state }, params) {
      var id = params.id
      params.id = undefined
      return dispatch('list', { basePath: `api/reception/${id}/attachments`, params: params }, { root: true })
        .then(response => {
          state.count = response.count
          state.page = params.page
          return response.results
        })
        .catch(error => { throw error })
    },
    async saveAttachments ({ dispatch, state }, params) {
      var id = params.id
      params.id = undefined
      return dispatch('save', { basePath: `api/reception/${id}/attachments`, data: params.formData }, { root: true })
        .then(response => {
          return response
        })
        .catch(error => { throw error })
    },
    async zipAttachments ({ dispatch, state }, params) {
      return dispatch('downloadFiles', { url: `api/reception/${params.id}/download_zip`, params: params.filters }, { root: true })
        .then(response => {
          return ''
        })
        .catch(error => { throw error })
    },
    async getQR ({ commit, state, getters, rootState }, params) {
      return this.dispatch('request', { method: 'get', url: `api/shipment/${params}/qr` })
        .then(
          response => {
            return response.data
          }
        )
    },
    async download ({ dispatch, state }, params) {
      return dispatch('downloadFiles', { url: `api/attachments/${params}/download` }, { root: true })
        .then(response => {
          return ''
        })
        .catch(error => { throw error })
    },
    async deleteDoc ({ dispatch, state }, id) {
      return dispatch('delete', { basePath: 'api/media', id: id }, { root: true })
        .then(response => {
          return response
        })
        .catch(error => { throw error })
    },
    async sendSms ({ dispatch, state }, data) {
      return dispatch('save', { basePath: `api/${data.basePath}/${data.id}/send_sms`, data: { msg: data.message } }, { root: true })
        .then(response => {
          state.object = response
          return response
        })
        .catch(error => { throw error })
    },
    async availableDates ({ dispatch, state }, params) {
      return dispatch('list', { basePath: 'api/reception/available_dates', params: params }, { root: true })
        .then(response => {
          return response.results
        })
    },
    async restrictedDates ({ dispatch, state }, params) {
      return dispatch('list', { basePath: 'api/restricted-dates', params: params }, { root: true })
        .then(response => {
          state.lockdownCount = response.count
          state.lockdownPage = params.page
          return response.results
        })
    },
    async createRestrictedDates ({ dispatch, state }, data) {
      return dispatch('save', { basePath: `api/restricted-dates`, data: data }, { root: true })
        .then(response => {
          return response
        })
        .catch(error => { throw error })
    },
    async deleteRestrictedDate ({ dispatch, state }, id) {
      return dispatch('delete', { basePath: 'api/restricted-dates', id: id }, { root: true })
        .then(response => {
          return response
        })
        .catch(error => { throw error })
    }
  },
  getters: {
    objects (state) { return state.objects }
  }
}



// WEBPACK FOOTER //
// ./src/store/lines.js